module.exports = __webpack_public_path__ + "media/images/icons/play_white-f20509d377b453090785759bf39823a2.svg";